// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"eabf4d35a70261987be7","777":"79045cb419b128f8864b"}[chunkId] + ".js";
};